import { render, staticRenderFns } from "./MileageSubMenu.vue?vue&type=template&id=a28c8f08&"
import script from "./MileageSubMenu.vue?vue&type=script&lang=js&"
export * from "./MileageSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports